var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { Log, LogCategory, Operation as LogOperation } from '@augloop/logging';
var WorkflowItemStorage = /** @class */ (function () {
    function WorkflowItemStorage(workflowDefinitionManager) {
        this.scopeItemsByContextId = new Map();
        this.itemsByWorkflowAndContextId = new Map();
        this.workflowDefinitionManager = workflowDefinitionManager;
    }
    WorkflowItemStorage.prototype.setScopeItem = function (scopeItem, workflow) {
        var contextId = scopeItem.contextId;
        if (!contextId) {
            return;
        }
        if (!this.scopeItemsByContextId.has(contextId)) {
            this.scopeItemsByContextId.set(contextId, scopeItem);
        }
        else {
            if (this.itemsByWorkflowAndContextId.has(workflow.id)) {
                var logOp = new LogOperation({
                    resultDescription: "Trying to set new scope item: " + scopeItem.id + " with already existing contextId " + contextId,
                    operationName: 'WIS.setScopeItem',
                    success: true
                }).start();
                Log.verbose(0x1f6dd398 /* tag_513oy */, LogCategory.CoreDefault, logOp.stop());
                return;
            }
        }
        if (!this.itemsByWorkflowAndContextId.has(workflow.id)) {
            this.itemsByWorkflowAndContextId.set(workflow.id, new Map());
        }
        this.itemsByWorkflowAndContextId.get(workflow.id).set(contextId, []);
    };
    WorkflowItemStorage.prototype.getScopeItem = function (contextId, workflow) {
        var _a;
        // Check if this contextId belongs to this workflowId execution
        if ((_a = this.itemsByWorkflowAndContextId.get(workflow.id)) === null || _a === void 0 ? void 0 : _a.has(contextId)) {
            return this.scopeItemsByContextId.get(contextId);
        }
        // This contextId belongs to a different join workflow execution, so no scope item for this execution
        return undefined;
    };
    WorkflowItemStorage.prototype.addItemToWorkflowList = function (item, workflow) {
        var _a, _b;
        var contextId = item.contextId;
        var itemsByContextId = this.itemsByWorkflowAndContextId.get(workflow.id);
        if (itemsByContextId) {
            (_a = itemsByContextId.get(contextId)) === null || _a === void 0 ? void 0 : _a.push(item);
            var logOp = new LogOperation({
                resultDescription: "Items for contextId " + contextId + ": [" + ((_b = itemsByContextId.get(contextId)) === null || _b === void 0 ? void 0 : _b.map(function (item) { return item.id; }).join(',')) + "]",
                operationName: 'WIS.addItemOnContextIdList',
                success: true
            }).start();
            Log.verbose(0x1f6dd399 /* tag_513oz */, LogCategory.CoreDefault, logOp.stop());
        }
    };
    WorkflowItemStorage.prototype.isWorkflowReady = function (contextId, workflow) {
        var maxAnnotations = this.workflowDefinitionManager.getWorkflowDefinition(workflow, contextId).maxAnnotations;
        return this.getGeneratedItems(contextId, workflow).length >= maxAnnotations;
    };
    WorkflowItemStorage.prototype.getItemsToExecute = function (contextId, workflow) {
        var items = this.getGeneratedItems(contextId, workflow);
        this.itemsByWorkflowAndContextId.get(workflow.id).delete(contextId);
        return items;
    };
    WorkflowItemStorage.prototype.onWorkflowExecuted = function (scopeItem, workflow) {
        var contextId = scopeItem.contextId;
        // delete annotation list of the current workflow executed
        var itemsByContextId = this.itemsByWorkflowAndContextId.get(workflow.id);
        if (itemsByContextId) {
            itemsByContextId.delete(contextId);
            if (itemsByContextId.size === 0) {
                this.itemsByWorkflowAndContextId.delete(workflow.id);
            }
        }
        // delete scope item if there isn't any workflow waiting for
        // an execution with this contextId
        if (!this.hasWorkflowsAwaitingExecution(contextId)) {
            this.scopeItemsByContextId.delete(contextId);
        }
    };
    WorkflowItemStorage.prototype.getGeneratedItems = function (contextId, workflow) {
        var _a;
        if (!((_a = this.itemsByWorkflowAndContextId.get(workflow.id)) === null || _a === void 0 ? void 0 : _a.get(contextId))) {
            return [];
        }
        var maxAnnotations = this.workflowDefinitionManager.getWorkflowDefinition(workflow, contextId).maxAnnotations;
        return this.itemsByWorkflowAndContextId.get(workflow.id).get(contextId).slice(0, maxAnnotations);
    };
    WorkflowItemStorage.prototype.hasWorkflowsAwaitingExecution = function (contextId) {
        var e_1, _a, e_2, _b;
        try {
            for (var _c = __values(this.itemsByWorkflowAndContextId.values()), _d = _c.next(); !_d.done; _d = _c.next()) {
                var itemsByContextId = _d.value;
                try {
                    for (var _e = (e_2 = void 0, __values(itemsByContextId.keys())), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var scopeContextId = _f.value;
                        if (scopeContextId === contextId) {
                            return true;
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return false;
    };
    return WorkflowItemStorage;
}());
export { WorkflowItemStorage };
//# sourceMappingURL=workflow-item-storage.js.map